<template>
    <div
        class="p-fluid bg-white p-3 borda-card-personalizada"
        style="border-radius: 0.125rem; padding-top: 1.5rem !important; padding-bottom: 2.3rem !important; min-height: 21rem !important"
    >
        <div>
            <h6 class="lato-bolder">Resumo Borderô</h6>
        </div>

        <div style="margin-top: 2rem">
            <DetalheDado titulo="Descrição">{{ bordero?.descricao }}</DetalheDado>
        </div>

        <hr style="margin-bottom: 2rem" />

        <div>
            <DetalheDado titulo="Valor do Lote">{{ bordero?.valorFormatado }}</DetalheDado>
        </div>

        <hr style="margin-bottom: 2rem" />

        <div>
            <DetalheDado titulo="Vencimento">{{ bordero?.validadeFormatada }}</DetalheDado>
        </div>
    </div>
</template>

<script>
import DetalheDado from './DetalheDado.vue';

export default {
    components: {
        DetalheDado,
    },

    props: {
        bordero: {
            type: Object,
        },
    },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap');

.lato-bolder {
    font-family: 'Lato', Arial, sans-serif;
    font-weight: 700;
}

.borda-card-personalizada {
    border: 1px solid #e0e3e7;
    font-size: 0.875rem;
}
</style>
